import AppRouter from "./AppRouter";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { PendingOrdersProvider } from "./context/PendingOrdersContext";
import theme from "./theme";
function App() {
  return (
    <PendingOrdersProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppRouter />
      </ThemeProvider>
    </PendingOrdersProvider>
  );
}

export default App;
